import { environment } from 'src/environments/environment';

export class Endpoint {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private params: string, private rawEndpoint = false) {}

  public get url(): string {
    if (this.rawEndpoint) {
      return `${this.params}`;
    }

    return `${this.apiBaseUrl}${this.params}`;
  }
}
